import actionTypes from 'redux/actions/actionTypes'

const defaultState = {
	videos: {},
	images: {},
	binaries: {},
}

function setAssetVideo(state, action) {
	return {
		...state,
		videos: {
			...state.videos,
			[action.video.uid]: action.video,
		},
	}
}

function setAssetImage(state, action) {
	return {
		...state,
		images: {
			...state.images,
			[action.poster.uid]: action.poster,
		},
	}
}

function setHandoutsAssets(state, action) {
	return {
		...state,
		binaries: action.assets
			.filter(asset => asset)
			.reduce((binaries, asset) => {
				binaries[asset.uid] = asset
				return binaries
			}, {...state.binaries}),
	}
}

const assetsReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.INTERACTIVE_VIDEO_ASSET_VIDEO_FETCHED:
		case actionTypes.MEDIA_SLIDE_FETCH_SUCCESS:
			return setAssetVideo(state, action)
		case actionTypes.INTERACTIVE_VIDEO_ASSET_POSTER_FETCHED:
			return setAssetImage(state, action)
		case actionTypes.INTERACTIVE_VIDEO_HANDOUTS_FETCHED:
			return setHandoutsAssets(state, action)
		default: return state
	}
}

export default assetsReducer
